import { OfferLetterFormsService } from 'api-clients/monolith/services/OfferLetterFormsService';
import { useCallback } from 'react';

import { useApiService, UseApiServiceOptions } from 'hooks/useApiService';

/**
 * Loads the Send Offer form definition for an applicant's offer stage
 * (AXHE-3717 `show`). Re-fetches when the selected template changes — the
 * server resolves a default by contract type when `offerLetterTemplateId` is
 * omitted.
 *
 * `options.enabled` exists for the offer review panel (AXHE-4759), which mounts
 * this hook for the whole time a panel is open but must only fetch once an
 * approver opens the edit form. The endpoint runs `authorize_applicant!` and
 * 403s an approver with no brand or location visibility on the applicant — which
 * is most of the people the panel serves — so fetching it eagerly would fire a
 * failing request on every panel open, for a form nobody asked for.
 */
export const useOfferLetterForm = (
  applicantExternalId: string,
  offerLetterTemplateId?: string,
  options?: UseApiServiceOptions,
) => {
  const fetchForm = useCallback(
    () =>
      OfferLetterFormsService.getInternalApiApplicantsOfferLetterForm(
        applicantExternalId,
        offerLetterTemplateId,
      ),
    [applicantExternalId, offerLetterTemplateId],
  );

  return useApiService(fetchForm, options);
};
